import { Box, BoxProps, useTheme } from "@mui/material";

export const OrnamentLandscape2: React.FC<BoxProps> = ({ sx, ...props }) => {
  const theme = useTheme();

  const hillsLight = theme.alpha(theme.palette.primary.main, 0.3);
  const hillsDark = theme.palette.primary.main;
  const strokes = theme.alpha(theme.palette.background.paper, 0.2);

  return (
    <Box
      sx={{
        lineHeight: 0,
        overflow: "hidden",
        pointerEvents: "none",
        "& svg": {
          width: "calc(100% + 2px)",
          height: "auto",
        },
        ...sx,
      }}
      {...props}
    >
      <svg
        width="2047"
        height="619"
        viewBox="0 0 2047 619"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_943_2424"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="2047"
          height="619"
        >
          <rect
            x="2046.3"
            y="618.43"
            width="2046.3"
            height="618.43"
            transform="rotate(180 2046.3 618.43)"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_943_2424)">
          <path
            d="M1023.58 313.426C405.986 368.35 511.254 649.272 230.024 614.452C162.054 606.037 81.7342 540.211 -0.995811 445.217L-0.99585 -1.99796L1660.38 -1.99811C1472.99 150.022 1242.17 293.987 1023.58 313.426Z"
            fill="url(#paint0_linear_943_2424)"
            stroke={strokes}
          />
          <path
            d="M1925.77 604.337C1103.51 677.463 1140.5 135.113 490.494 159.487C210.714 169.979 80.7242 128.983 23.4142 -1.9983L2047 -1.99847L2047 584.568C2010.88 593.66 1970.59 600.352 1925.77 604.337Z"
            fill="url(#paint1_linear_943_2424)"
            stroke={strokes}
          />
          <path
            d="M1342.89 406.658C627.336 470.294 468.864 261.121 -0.995813 214.138L-0.995832 -1.99796L2042.42 -1.99814C1995.76 244.093 1794.43 366.501 1342.89 406.658Z"
            fill="url(#paint2_linear_943_2424)"
            stroke={strokes}
          />
          <path
            d="M767.474 417.24C241.604 476.947 61.1445 232.037 5.53444 -1.99836L1666.25 -1.9985C1663.25 0.637499 1660.23 3.2915 1657.18 5.9625C1782.98 -23.0627 1728.52 308.125 767.474 417.24Z"
            fill="url(#paint3_linear_943_2424)"
            stroke={strokes}
          />
          <path
            d="M706.304 -1.99847C651.974 190.584 508.794 326.26 87.6139 306.027C56.6239 304.539 27.104 300.455 -0.996041 294.16L-0.996067 -1.99841L706.304 -1.99847Z"
            fill="url(#paint4_linear_943_2424)"
            stroke={strokes}
          />
          <path
            d="M2047 394.841C1444.52 410.41 1400.4 222.687 815.364 244.625C529.664 255.338 337.394 135.591 211.624 -1.99816L2047 -1.99832L2047 394.841Z"
            fill="url(#paint5_linear_943_2424)"
            stroke={strokes}
          />
          <path
            d="M134.484 161.75C88.2439 166.71 43.014 166.564 -0.99604 162.186L-0.996054 -1.99825L784.474 -1.99832C634.674 60.8407 450.724 127.831 134.484 161.75Z"
            fill="url(#paint6_linear_943_2424)"
            stroke={strokes}
          />
          <path
            d="M2047 326.18C1295.61 375.583 1359 57.0867 843.294 57.0867C583.374 57.0868 260.624 30.9418 -0.995824 4.27182L-0.995825 -1.9982L2047 -1.99838L2047 326.18Z"
            fill="url(#paint7_linear_943_2424)"
            stroke={strokes}
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_943_2424"
            x1="829.693"
            y1="696.744"
            x2="829.693"
            y2="-1.99829"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={hillsLight} />
            <stop offset="1" stopColor={hillsDark} />
          </linearGradient>
          <linearGradient
            id="paint1_linear_943_2424"
            x1="1035.21"
            y1="681.125"
            x2="1035.21"
            y2="-2.99841"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={hillsLight} />
            <stop offset="1" stopColor={hillsDark} />
          </linearGradient>
          <linearGradient
            id="paint2_linear_943_2424"
            x1="1020.71"
            y1="576.932"
            x2="1020.71"
            y2="-1.9985"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={hillsLight} />
            <stop offset="1" stopColor={hillsDark} />
          </linearGradient>
          <linearGradient
            id="paint3_linear_943_2424"
            x1="835.89"
            y1="426.339"
            x2="835.89"
            y2="-1.99843"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={hillsLight} />
            <stop offset="1" stopColor={hillsDark} />
          </linearGradient>
          <linearGradient
            id="paint4_linear_943_2424"
            x1="352.654"
            y1="308.024"
            x2="352.654"
            y2="-1.99844"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={hillsLight} />
            <stop offset="1" stopColor={hillsDark} />
          </linearGradient>
          <linearGradient
            id="paint5_linear_943_2424"
            x1="1129.31"
            y1="395.76"
            x2="1129.31"
            y2="-1.99824"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={hillsLight} />
            <stop offset="1" stopColor={hillsDark} />
          </linearGradient>
          <linearGradient
            id="paint6_linear_943_2424"
            x1="391.739"
            y1="165.47"
            x2="391.739"
            y2="-1.99829"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={hillsLight} />
            <stop offset="1" stopColor={hillsDark} />
          </linearGradient>
          <linearGradient
            id="paint7_linear_943_2424"
            x1="1023"
            y1="331.385"
            x2="1023"
            y2="-1.99829"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={hillsLight} />
            <stop offset="1" stopColor={hillsDark} />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
};
